import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/github/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/github/workspace/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/react-toastify/dist/ReactToastify.css");
